import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlbums: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAlbums"><Path fillRule="evenodd" clipRule="evenodd" d="M11 2.79492L21 4.66992V19.3298L11 21.2048V2.79492ZM9 3.99985V19.9998H7V3.99985H9ZM5 4.99985V18.9998H3V4.99985H5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAlbums;
